<template>
  <div class="table-wrapper">
    <div v-if="showHeader" class="header" :class="{'is-extend': isExtend}">
      <div class="title" :class="{'is-extend': isExtend}" @click="extendQuery">
        <span>{{ title }}</span>
        <img src="@/assets/images/table-title-select.png" alt="">
      </div>
      <div v-show="!isExtend" class="table-common__button">
        <slot name="button" />
        <table-button v-if="showCustome" name="column-config" tip="配置" @click="customeConfig" />
      </div>
    </div>

    <el-collapse-transition>
      <div v-show="!isExtend" class="btk-table">
        <slot />
        <div v-if="pagination !== null" class="table-footer">
          <Pagination :pagination="pagination" @pagination-change="handleTablePaginationChange" />
          <div class="exprot">
            <span v-if="exportAll !== false && exportAll !== undefined" class="export-all" @click="exportExcel('all')">
              <img src="@/assets/images/export.png">导出全部
            </span>
            <span v-if="exportPage !== false && exportPage !== undefined" class="export-page" @click="exportExcel('page')">
              <img src="@/assets/images/export.png">导出
            </span>
          </div>
        </div>
      </div>
    </el-collapse-transition>

  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    exportAll: {
      type: String || Boolean,
      default: undefined
    },
    exportPage: {
      type: String || Boolean,
      default: undefined
    },
    pagination: {
      type: Object,
      default: () => null
    },
    customeConfig: {
      type: Function,
      default: () => {}
    },
    showCustome: {
      type: [Boolean, String],
      default: true
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isExtend: false
    }
  },
  created() {
    console.log(this.exportAll)
  },
  methods: {
    extendQuery() {
      this.isExtend = !this.isExtend
    },
    handleTablePaginationChange(page) {
      this.$emit('pagination-change', page)
    },
    exportExcel(type) {
      this.$emit('exportExcel', type)
    }
  }
}
</script>

<style lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/TableCommon/index.vue